import * as authEvents from "../../store/events/auth";
import BasicModal from "../Modal/BasicModal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import HeaderIconLink from "./HeaderIconLink";
import HeaderTextLink from "./HeaderTextLink";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import Logo from "./Logo.js";
import ProfilePopover from "./ProfilePopover.js";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import { styled } from "@mui/material/styles";
import { useBreakpoint } from "@pheaa/channels-component-library";
import useNavigateQSA from "../../utils/hooks/useNavigateQSA";
import { useTheme } from "@mui/material";
import {
	HELP_MODULE_CONTEXT,
	HELP_MODULE_DEFAULT,
	HELP_MODULE_KEY
} from "../../config/common";
import React, { useState } from "react";

const HeaderLinkDivider = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.primary.contrastText,
	flex: "0 0 auto",
	height: 54,
	marginLeft: 12,
	marginRight: 12,
	opacity: 0.75,
	width: "1px"
}));

const IconInbox = props => {
	return (
		<SvgIcon {...props}>
			<path fill="transparent" d="M1.5 1H23.5V15H1.5V1Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path fill="transparent" d="M1.5 1L12.5 11.15L23.5 1M16.1667 7.86L23.5 15M1.5 15L8.83333 7.86" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</SvgIcon>
	);
};

const IconMenu = props => {
	return (
		<SvgIcon {...props}>
			<path d="M4.3 0H21.7C22.418 0 23 0.58203 23 1.3C23 2.01797 22.418 2.6 21.7 2.6H4.3C3.58203 2.6 3 2.01797 3 1.3C3 0.58203 3.58203 0 4.3 0ZM4.3 5.2H21.7C22.418 5.2 23 5.78203 23 6.5C23 7.21797 22.418 7.8 21.7 7.8H4.3C3.58203 7.8 3 7.21797 3 6.5C3 5.78203 3.58203 5.2 4.3 5.2ZM4.3 10.4H21.7C22.418 10.4 23 10.982 23 11.7C23 12.418 22.418 13 21.7 13H4.3C3.58203 13 3 12.418 3 11.7C3 10.982 3.58203 10.4 4.3 10.4Z" fill="white" />
		</SvgIcon>
	);
};

const IconProfile = props => {
	return (
		<SvgIcon {...props}>
			<path fill="transparent" d="M7.96667 13V13.9057C7.96667 14.4717 7.65 15.3774 4.48333 15.8868C2.69811 16.1543 1.29929 17.4045 1 19H20C19.4941 17.4035 18.0235 16.1987 16.2 15.8868C13.0333 15.3491 13.0333 14.4717 13.0333 13.9057V13.1843" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path fill="transparent" d="M15 8.30476C15 11.4 12.975 14 10.5 14C8.025 14 6 11.5238 6 8.42857V5.45714C6 2.2381 8.37857 1 10.5 1C12.6214 1 15 2.11429 15 5.33333V8.30476Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</SvgIcon>
	);
};

const IconSignOut = props => {
	return (
		<SvgIcon height="18" viewBox="0 0 27 18" width="27" {...props} >
			<path fill="transparent" d="M10.8462 5.92308V1H1V17H10.8462V12.0769" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
			<path fill="transparent" d="M10.8461 8.99997H25.3077M25.3077 8.99997L21.3077 12.3846M25.3077 8.99997L21.3077 5.61536" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
		</SvgIcon>
	);
};

const headerBreakpointConfig = [{
	key: "small",
	value: 320
}, {
	key: "medium",
	value: 768
}];

const Navigation = props => {

	let returnElem = null;

	const breakpoint = useBreakpoint(headerBreakpointConfig);
	const [isNavigationOpen, setNavigationOpen] = useState(false);
	const navigate = useNavigateQSA();
	const theme = useTheme();

	const handleClickHelp = e => {
		e.preventDefault();
		navigate({ search: { [HELP_MODULE_KEY]: HELP_MODULE_DEFAULT } });
	};

	const handleMenuOpen = e => {
		e.preventDefault();
		setNavigationOpen(true);
	};

	const handleMenuClose = e => {
		e.preventDefault();
		setNavigationOpen(false);
	};

	if (breakpoint.key === "medium") {
		returnElem = (
			<nav className="cmp-header__nav">
				<ul>
					<li><HeaderTextLink text="Home" to="/" /></li>
					<li><HeaderTextLink onClick={handleClickHelp} text="Help" to={HELP_MODULE_CONTEXT} /></li>
				</ul>
			</nav>
		);
	} else {

		const NavListItem = styled(Box)(({ theme }) => ({
			borderBottom: "0.1rem solid #3B4557"
		}));

		const NavListItemLink = styled(Box)(({ theme }) => ({
			alignItems: "center",
			color: "white",
			display: "flex",
			fontSize: "2rem",
			minHeight: "7.8rem",
			padding: "1rem 3.2rem",
			textDecoration: "none",
			"&:focus": { textDecoration: "underline" },
			"&:hover": { textDecoration: "underline" }
		}));

		returnElem = (
			<div>
				<IconButton
					onClick={handleMenuOpen}
					sx={{
						alignItems: "center",
						display: "flex",
						flexDirection: "column",
						minHeight: 85
					}}
				>
					<IconMenu />
					<Box
						sx={{
							color: theme.palette.primary.contrastText,
							fontFamily: theme.typography.fontFamily,
							fontSize: 10,
							fontWeight: 600,
							justifyContent: "center"
						}}
					>
						Menu
					</Box>
				</IconButton>
				<BasicModal
					open={isNavigationOpen}
					style={{
						backgroundColor: theme.palette.primary.main,
						borderRadius: 0,
						inset: 0,
						padding: 0,
						transform: "none",
						width: "35rem"
					}}
				>
					<Box sx={{ display: "flex", justifyContent: "flex-end", padding: "1rem 2.4rem", minHeight: "7.8rem" }}>
						<IconButton
							onClick={handleMenuClose}
							sx={{ color: "white", display: "flex", flexDirection: "column" }}
						>
							<CloseIcon fill="white" fontSize="large" />
							<Typography color="white" component="span" fontSize="1.2rem">Close</Typography>
						</IconButton>
					</Box>
					<Box component="nav">
						<Box component="ul" sx={{ borderTop: "0.1rem solid #3B4557" }}>
							<NavListItem component="li">
								<NavListItemLink component={Link} to="/">Home</NavListItemLink>
							</NavListItem>
							<NavListItem component="li">
								<NavListItemLink component={Link} onClick={handleClickHelp} to={HELP_MODULE_CONTEXT}>Help</NavListItemLink>
							</NavListItem>
						</Box>
					</Box>
				</BasicModal>
			</div>
		);
	}

	return returnElem;
};

const Header = props => {

	const {
		endSession,
		isPendingSessionEnd,
		isSuppressingNav = false
	} = props;

	const theme = useTheme();
	const breakpoint = useBreakpoint(headerBreakpointConfig);
	const backgroundColor = (theme.palette.primary.main);

	const handleSignOut = e => {
		e.preventDefault();
		!isPendingSessionEnd && endSession();
	};

	return (
		<Box
			className="cmp-header"
			component="header"
			id="header"
			sx={{
				backgroundColor,
				boxShadow: 3,
				zIndex: "+1"
			}}
		>
			<Box className="cmp-header__inner">
				<Box component="h1" className="a11y-hidden" sx={{ color: theme.palette.common.white }}>Consumer Guaranty Portal</Box>
				<div className="cmp-header__grid">
					<Logo />
					<Navigation />
					<div className="cmp-header__quick-nav">
						{!isSuppressingNav && (
							<HeaderIconLink
								icon={<IconInbox />}
								text="Inbox"
								to="/inbox"
							/>)}
						{!isSuppressingNav && (
							<ProfilePopover
								bypassPopover={breakpoint.key === "medium"}
								handleSignOut={handleSignOut}
								icon={<IconProfile />}
								text="Profile"
								to="/profile"
							/>
						)}
						{!isSuppressingNav && breakpoint.key === "medium" && <HeaderLinkDivider />}
						{!isSuppressingNav && breakpoint.key === "medium" && (
							<HeaderIconLink
								icon={<IconSignOut />}
								onClick={handleSignOut}
								text="Sign Out"
								textWrap={false}
								to="/sign-out"
							/>
						)}
					</div>
				</div>
			</Box>
		</Box>
	);
};

const mapStateToProps = state => {
	return {
		isPendingSessionEnd: state.auth.isPendingSessionEnd
	};
};

const mapDispatchToProps = dispatch => {
	return {
		endSession: data => dispatch(authEvents.endSession(data))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
export { IconProfile, headerBreakpointConfig };